import React, { useState } from 'react';
import useStyle from './radioOrderNumber.style';
import { classNames } from 'helpers/style/classNames';

export interface RadioOrderNumberProps {
  numberOfOrders: number;
  numberOfUnPayedOrders?: number;
  numberOfPayedOrders?: number;
  numberOfCanceledOrders?: number;
  isDesktop: boolean;
  handleClick: (value: string) => void;
}

export const RadioOrderNumber = ({
  numberOfOrders,
  numberOfPayedOrders = 0,
  numberOfUnPayedOrders = 0,
  numberOfCanceledOrders = 0,
  isDesktop,
  handleClick
}: RadioOrderNumberProps) => {
  const classes = useStyle({ isDesktop });
  const [checkedValue, setCheckedValue] = useState('all');

  const onHandleClick = (value: string) => {
    handleClick(value);
    setCheckedValue(value);
  };

  return (
    <div className={classes.root}>
      <div className={classes.radioItem}>
        <input
          type="radio"
          name="OrdersFilter"
          id="all"
          value="all"
          defaultChecked={checkedValue === 'all'}
          onClick={() => onHandleClick('all')}
        />
        <label htmlFor="all">
          <span className={classNames([classes.numSquare, classes.blue])}>
            {numberOfOrders}
          </span>
          Toutes les commandes
        </label>
      </div>
      <div className={classes.radioItem}>
        <input
          type="radio"
          name="OrdersFilter"
          id="payed"
          value="payed"
          defaultChecked={checkedValue === 'payed'}
          onChange={() => onHandleClick('payed')}
        />
        <label htmlFor="payed">
          <span className={classNames([classes.numSquare, classes.green])}>
            {numberOfPayedOrders}
          </span>
          Commandes payées
        </label>
      </div>
      <div className={classes.radioItem}>
        <input
          type="radio"
          name="OrdersFilter"
          id="unPayed"
          value="unPayed"
          defaultChecked={checkedValue === 'unPayed'}
          onClick={() => onHandleClick('unPayed')}
        />
        <label htmlFor="unPayed">
          <span className={classNames([classes.numSquare, classes.red])}>
            {numberOfUnPayedOrders}
          </span>
          Commandes non payées
        </label>
      </div>
      <div className={classes.radioItem}>
        <input
          type="radio"
          name="OrdersFilter"
          id="canceled"
          value="canceled"
          defaultChecked={checkedValue === 'canceled'}
          onClick={() => onHandleClick('canceled')}
        />
        <label htmlFor="canceled">
          <span className={classNames([classes.numSquare, classes.gray])}>
            {numberOfCanceledOrders}
          </span>
          Commandes annulées
        </label>
      </div>
    </div>
  );
};
